// nav-mobile.js: Handles mobile unfurl for nav-modal link-groups

document.addEventListener('DOMContentLoaded', function () {
  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  const navModal = document.getElementById('nav-modal');
  if (!navModal) return;

  // Removed double‑tap to expand logic: mobile link-headers now behave as normal links (single tap navigates)
  // (Previously attached click handlers intercepted first tap; now omitted.)

  // Optional: ensure any previously added 'open' classes (from cached DOM) are cleared
  if (isMobile()) {
    navModal.querySelectorAll('.link-group.open').forEach(g => g.classList.remove('open'));
  }

  // --- Control only the close-nav-video on hover; leave open-nav-video looping/idle-animation alone ---
  const navLogoCloseVideo = document.querySelector('nav .logo video.close-nav-video');
  const navLogoImg = document.querySelector('nav .logo .logo-image');
  const isHomepage = document.body.classList.contains('is-homepage');
  if (navLogoCloseVideo) {
    navLogoCloseVideo.pause();
    navLogoCloseVideo.currentTime = 0;
    navLogoCloseVideo.muted = true;
    navLogoCloseVideo.removeAttribute('autoplay');
    navLogoCloseVideo.removeAttribute('loop');
    const logoParent = navLogoCloseVideo.closest('.logo');
    let reverseInterval = null;
    if (logoParent) {
      logoParent.addEventListener('mouseenter', () => {
        if (reverseInterval) { clearInterval(reverseInterval); reverseInterval = null; }
        navLogoCloseVideo.currentTime = 0;
        navLogoCloseVideo.playbackRate = 1;
        navLogoCloseVideo.play();
        if (isHomepage && navLogoImg) {
          navLogoImg.style.opacity = '0';
          navLogoCloseVideo.style.opacity = '1';
          logoParent.style.backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--red') || '#ff0000';
        }
      });
      logoParent.addEventListener('mouseleave', () => {
        navLogoCloseVideo.pause();
        navLogoCloseVideo.playbackRate = 1;
        if (isHomepage && navLogoImg) {
          let fadeInDone = false;
          logoParent.style.backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--red') || '#ff0000';
          reverseInterval = setInterval(() => {
            if (navLogoCloseVideo.currentTime > 0.03) {
              navLogoCloseVideo.currentTime -= 0.033;
            } else {
              navLogoCloseVideo.currentTime = 0;
              clearInterval(reverseInterval);
              reverseInterval = null;
              if (!fadeInDone) {
                if (navLogoImg) { navLogoImg.style.transition = 'opacity 0.3s'; navLogoImg.style.opacity = '1'; }
                navLogoCloseVideo.style.transition = 'opacity 0.3s';
                navLogoCloseVideo.style.opacity = '0';
                setTimeout(() => { logoParent.style.backgroundColor = 'transparent'; }, 300);
                fadeInDone = true;
              }
            }
          }, 33);
        } else {
          reverseInterval = setInterval(() => {
            if (navLogoCloseVideo.currentTime > 0.03) {
              navLogoCloseVideo.currentTime -= 0.033;
            } else {
              navLogoCloseVideo.currentTime = 0;
              clearInterval(reverseInterval);
              reverseInterval = null;
            }
          }, 33);
        }
      });
      logoParent.addEventListener('focus', () => {
        if (reverseInterval) { clearInterval(reverseInterval); reverseInterval = null; }
        navLogoCloseVideo.currentTime = 0;
        navLogoCloseVideo.playbackRate = 1;
        navLogoCloseVideo.play();
        if (isHomepage && navLogoImg) { navLogoImg.style.opacity = '0'; }
      });
      logoParent.addEventListener('blur', () => {
        navLogoCloseVideo.pause();
        navLogoCloseVideo.currentTime = 0;
        if (reverseInterval) { clearInterval(reverseInterval); reverseInterval = null; }
        if (isHomepage && navLogoImg) { navLogoImg.style.opacity = '1'; }
      });
    }
  }
});
